<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4 4.75C4 4.33579 4.33579 4 4.75 4H10.7604C11.1746 4 11.5104 4.33579 11.5104 4.75C11.5104 5.16421 11.1746 5.5 10.7604 5.5H6.56066L11.8211 10.7604C12.114 11.0533 12.114 11.5282 11.8211 11.8211C11.5282 12.114 11.0533 12.114 10.7604 11.8211L5.5 6.56066V10.7604C5.5 11.1746 5.16421 11.5104 4.75 11.5104C4.33579 11.5104 4 11.1746 4 10.7604V4.75Z"
    fill="currentColor"
  />
</svg>
